import script from "./XButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./XButton.vue?vue&type=script&lang=ts&setup=true"

import "./XButton.vue?vue&type=style&index=0&id=0f3720fc&lang=scss&scoped=true"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f3720fc"]])

export default __exports__